import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  ReferenceField,
  ShowButton,
  EditButton,
  TextField,
  BooleanField,
  TextInput,
  BooleanInput,
  SelectInput,
  ReferenceInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

import { IsolatesDetailShow } from "./IsolatesDetailShow";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,
  // <TextInput label="Isolate" source="isolate" />,
  <BooleanInput label="Is isolated" source="is_isolated" />,
  <BooleanInput label="Has sequence" source="has_sequence" />,
  <BooleanInput label="Has picture" source="has_picture" />,
  <ReferenceInput label="Culture" source="id_culture" reference="cultures">
    <SelectInput optionText="culture" />
  </ReferenceInput>,
  <ReferenceInput label="Sample" source="id_sample" reference="samples">
    <SelectInput optionText="code" />
  </ReferenceInput>,
  <TextInput label="Notes" source="notes" />,
];

export const IsolatesList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    sort={{ field: "code", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={100}
  >
    <Datagrid expand={<IsolatesDetailShow />}>
      <TextField label="Isolate code" source="code" />
      {/* <TextField source="isolate" /> */}
      <BooleanField source="is_isolated" />
      <BooleanField source="has_sequence" />
      <BooleanField source="has_picture" />

      <ReferenceField
        label="Culture"
        source="id_culture"
        reference="cultures"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>
      <ReferenceField
        label="Sample"
        source="id_sample"
        reference="samples"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>

      <TextField source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
